import {PayloadItemModel} from '../../../../../../../../core';
import {SearchEntity} from '../entity/search.models';

export class GetPayload extends PayloadItemModel<SearchEntity> {
}
